import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import checkApiStatus from '../../component/SubscripStatus';
import videoApi from '../../api/videoApi';
import Toast from '../../utils/toastManager';
import api from '../../data/api';
import { VideoContext } from '../../Pages/VideoPlayer/VideoContext';
import { userInfoAtom } from '../../data/atoms/utilsAtoms';
import { getSignupRoute } from '../../constants/featureFlags';
import { sendClickEvent, sendConversionEvent } from '@/service/algolia';

export const useVideoInteractions = ({ responseData, setResponseData }) => {
	const [modal, setModal] = useState(false);
	const [videoData2, setVideoData2] = useState({});
	const [videoData, setVideoData] = useState({});
	const [savedVideoIds, setSavedVideoIds] = useState([]);
	const { selectedVideo, setSelectedVideo } = useContext(VideoContext);
	const userData = useAtomValue(userInfoAtom);
	const redirect = useNavigate();

	// Fetch saved video IDs
	useEffect(() => {
		if (userData?.token) {
			videoApi.getAllSavedVideoIds(userData.user.userId).then(res => {
				setSavedVideoIds(res.data.savedVideos);
			});
		}
	}, [userData.token, responseData]);

	// Set video data from localStorage or context
	useEffect(() => {
		const data = window.localStorage.getItem('selectedVideo');
		if (data) {
			setVideoData(JSON.parse(data));
		}
	}, []);

	useEffect(() => {
		if (selectedVideo) {
			setVideoData(selectedVideo);
		}
	}, [selectedVideo]);

	// Handle like/unlike video
	const handleSubmit = async (id, video) => {
		const isLiked =
			video.videoDetails?.savedvideo ||
			video.savedvideo ||
			(savedVideoIds?.length > 0 && savedVideoIds?.includes(video?.videoDetails?._id || video?._id));
		try {
			if (isLiked) {
				const response = await api.unsaveWishlist(id, userData?.token);
				if (response.status === 200) {
					updateVideoSavedStatus(id, false);
				}
			} else {
				const response = await api.saveWishlist(id, userData?.token);
				if (response.status === 200) {
					updateVideoSavedStatus(id, true);
					sendConversionEvent({
						objectID: String(id),
						userToken: userData?.user?._id || userData?.user?.userId || 'anonymous',
						eventName: 'Video Saved',
					});
				}
			}
		} catch (error) {
			console.error('Error updating video save status: ', error);
		}
	};

	// Update video saved status in state
	const updateVideoSavedStatus = (id, savedStatus) => {
		const updatedResponseData = responseData.map(item => {
			const updatedVideos = item.videos.map(video => {
				if (video?.videoDetails?._id === id) {
					return {
						...video,
						videoDetails: {
							...video.videoDetails,
							savedvideo: savedStatus
						}
					};
				} else if (video?._id === id) {
					return {
						...video,
						savedvideo: savedStatus
					};
				}
				return video;
			});
			return {
				...item,
				videos: updatedVideos
			};
		});
		setResponseData(updatedResponseData);
	};

	// Navigate to player page
	const handlePlayerVideo = async id => {
		sendClickEvent({
			objectID: String(id),
			userToken: userData?.user?._id || userData?.user?.userId || 'anonymous',
		});
		const apistatus = await checkApiStatus(userData?.token);
		if (userData.token) {
			if (apistatus) {
				redirect(`/PlayerPage?v=${id}`);
			} else {
				// User is logged in but not subscribed
				redirect('/Plans');
			}
	} else {
			// User is not logged in
			redirect(getSignupRoute());
		}
	};

	// Open add to playlist modal
	const handelSubmitPlaylist = async id => {
		try {
			const response = await api.videoPlayerPage(id);
			if (response.status === 200) {
				const jsonData = response.data[0];
				setVideoData2(jsonData);
				setModal(true);
			}
		} catch (error) {
			Toast.error('Something went wrong');
		}
	};

	return {
		handleSubmit,
		handlePlayerVideo,
		handelSubmitPlaylist,
		savedVideoIds,
		modal,
		setModal,
		videoData,
		videoData2,
		setVideoData2
	};
};
